import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import InsightsIcon from "@mui/icons-material/InsightsOutlined";
import ShareIcon from "@mui/icons-material/ShareOutlined";
import PeopleIcon from "@mui/icons-material/PeopleAltOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmberOutlined";
import StorefrontIcon from "@mui/icons-material/StorefrontOutlined";
import HandshakeIcon from "@mui/icons-material/HandshakeOutlined";
import ReportProblemIcon from "@mui/icons-material/ReportProblemOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLongOutlined";
import LocalShippingIcon from "@mui/icons-material/LocalShippingOutlined";
import DomainIcon from "@mui/icons-material/DomainOutlined";
import LocationCityIcon from "@mui/icons-material/LocationCityOutlined";
import CategoryIcon from "@mui/icons-material/CategoryOutlined";
import PriceChangeIcon from "@mui/icons-material/PriceChangeOutlined";
import CampaignIcon from "@mui/icons-material/CampaignOutlined";
import LocalOfferIcon from "@mui/icons-material/LocalOfferOutlined";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcardOutlined";
import ChatIcon from "@mui/icons-material/ChatOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActiveOutlined";
import PaidIcon from "@mui/icons-material/PaidOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import LockResetIcon from "@mui/icons-material/LockResetOutlined";
import SellIcon from "@mui/icons-material/SellOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";

// Sidebar is data-driven and grouped into sections so new items can be added
// here without touching the sidebar/layout components.
const sidebarSections = [
  {
    label: "Overview",
    items: [
      { label: "Dashboard", path: "/admin/dashboard", icon: DashboardIcon },
      { label: "Analytics", path: "/admin/analytics", icon: InsightsIcon },
      { label: "Social Media", path: "/admin/social-media", icon: ShareIcon },
    ],
  },
  {
    label: "People",
    items: [
      { label: "Users", path: "/admin/users", icon: PeopleIcon },
      { label: "Account Access", path: "/admin/account-access", icon: LockResetIcon },
      { label: "Warnings & Blocked", path: "/admin/client-warnings", icon: WarningAmberIcon },
      { label: "Wholesale Clients", path: "/admin/wholesale-clients", icon: SellIcon },
    ],
  },
  {
    label: "Marketplace",
    items: [
      { label: "Stores", path: "/admin/stores", icon: StorefrontIcon },
      { label: "Partner Requests", path: "/admin/partner-requests", icon: HandshakeIcon },
      { label: "Categories", path: "/admin/categories", icon: CategoryIcon },
      { label: "Import Products", path: "/admin/product-imports", icon: CloudDownloadOutlinedIcon },
      { label: "Attributes", path: "/admin/attributes", icon: TuneOutlinedIcon },
      { label: "Authenticity Options", path: "/admin/authenticity-options", icon: VerifiedOutlinedIcon },
      { label: "Advertisements", path: "/admin/advertisements", icon: CampaignIcon },
      { label: "Coupons", path: "/admin/coupons", icon: LocalOfferIcon },
      { label: "Gift Offers", path: "/admin/gift-offers", icon: CardGiftcardIcon },
    ],
  },
  {
    label: "Operations",
    items: [
      { label: "Orders", path: "/admin/orders", icon: ReceiptLongIcon },
      { label: "Delete Orders", path: "/admin/delete-orders", icon: DeleteOutlineIcon },
      { label: "Delivery", path: "/admin/delivery", icon: LocalShippingIcon },
      { label: "Delivery Companies", path: "/admin/delivery-companies", icon: DomainIcon },
      { label: "Delivery Pricing", path: "/admin/delivery-pricing", icon: PriceChangeIcon },
      { label: "Cities", path: "/admin/cities", icon: LocationCityIcon },
      { label: "Chats", path: "/admin/chats", icon: ChatIcon },
      { label: "Notifications", path: "/admin/notifications", icon: NotificationsActiveIcon },
      { label: "Reports & Cases", path: "/admin/reports", icon: ReportProblemIcon },
    ],
  },
  {
    label: "Finance",
    items: [
      { label: "Fees & Subscriptions", path: "/admin/fees-subscriptions", icon: PaidIcon },
      { label: "Store Fees", path: "/admin/delivery-companies/store-fees", icon: DomainIcon },
    ],
  },
  {
    label: "System",
    items: [{ label: "Settings", path: "/admin/settings", icon: SettingsIcon }],
  },
];

// Flat list kept for consumers that just need path/label/icon lookups.
export const sidebarConfig = sidebarSections.flatMap((section) => section.items);

export default sidebarSections;
